import { render, staticRenderFns } from "./H2ReportVisit.vue?vue&type=template&id=5b5fcb23&scoped=true"
import script from "./H2ReportVisit.vue?vue&type=script&lang=js"
export * from "./H2ReportVisit.vue?vue&type=script&lang=js"
import style0 from "./H2ReportVisit.vue?vue&type=style&index=0&id=5b5fcb23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5fcb23",
  null
  
)

export default component.exports